import { Link } from "react-router-dom";
import TopBar from "@/components/feature/TopBar";
import Footer from "@/components/feature/Footer";
import LpForm from "../components/LpForm";
import { PHONE } from "@/mocks/updiag";

const faqItems = [
  { q: "Combien coûte un DPE à Paris ?", a: "Le DPE à Paris coûte dès 130 € TTC pour un studio ou T1 (moins de 35 m²), 150 € pour un T2/T3 (35–80 m²) et 180 € pour un T4+ ou maison. Le déplacement est inclus dans tous nos tarifs." },
  { q: "Sous quel délai intervenez-vous à Paris ?", a: "Nous intervenons dans tous les arrondissements de Paris sous 48h. En cas d'urgence, contactez-nous directement par téléphone pour un rendez-vous le jour même." },
  { q: "Le DPE est-il obligatoire pour vendre à Paris ?", a: "Oui, le DPE est obligatoire pour toute vente immobilière à Paris. Il doit être annexé à la promesse de vente et mentionné dans l'annonce immobilière avec l'étiquette énergie." },
  { q: "Combien de temps dure la visite pour un DPE à Paris ?", a: "La visite dure entre 1h et 2h selon la surface. Vous recevez votre rapport certifié par email le jour même de l'intervention." },
];

const arrondissements = [
  "Paris 1er", "Paris 2e", "Paris 3e", "Paris 4e", "Paris 5e", "Paris 6e", "Paris 7e",
  "Paris 8e", "Paris 9e", "Paris 10e", "Paris 11e", "Paris 12e", "Paris 13e", "Paris 14e",
  "Paris 15e", "Paris 16e", "Paris 17e", "Paris 18e", "Paris 19e", "Paris 20e",
];

export default function LpDpeParisExpress() {
  return (
    <>
      <title>DPE Paris Express — Diagnostic Énergétique Dès 130 € | Intervention 48h | Up Diag</title>
      <meta name="description" content="DPE Paris express : diagnostic de performance énergétique certifié COFRAC dans tous les arrondissements. Dès 130 €, RDV sous 48h, rapport le jour même." />
      <meta name="robots" content="noindex" />
      <TopBar />

      {/* LP Header simplifié */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-9 h-9 bg-[#0F3B5F] rounded-xl flex items-center justify-center">
              <i className="ri-home-gear-fill text-white text-lg"></i>
            </div>
            <div>
              <div className="font-bold text-lg text-[#0F3B5F] leading-none" style={{ fontFamily: "Barlow, sans-serif" }}>Up Diag</div>
              <div className="text-[9px] text-gray-400 leading-none">Diagnostic immobilier certifié</div>
            </div>
          </Link>
          <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="flex items-center gap-2 px-5 py-2.5 bg-[#F97316] text-white rounded-xl font-bold text-sm hover:bg-orange-600 transition-all whitespace-nowrap">
            <i className="ri-phone-fill"></i> {PHONE}
          </a>
        </div>
      </header>

      <main>
        {/* Hero */}
        <section className="relative min-h-[600px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="/img/readdy/lp1-hero.jpg"
              alt="DPE Paris express"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0F3B5F]/92 via-[#0F3B5F]/75 to-[#0F3B5F]/30"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-6 py-16 w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Left */}
              <div>
                {/* Urgency badge */}
                <div className="inline-flex items-center gap-2 bg-[#F97316] text-white text-xs font-bold px-4 py-2 rounded-full mb-6 animate-pulse">
                  <i className="ri-timer-flash-fill"></i>
                  Intervention sous 48h — Paris &amp; IDF
                </div>

                <h1 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>
                  DPE Paris Express<br />
                  <span className="text-[#F97316]">Dès 130 € — Rapport<br />le jour même</span>
                </h1>

                <p className="text-lg text-white/85 mb-8 max-w-lg">
                  Diagnostic de Performance Énergétique certifié COFRAC dans tous les arrondissements de Paris. Obligatoire pour vendre ou louer votre bien.
                </p>

                {/* Points clés */}
                <div className="flex flex-col gap-3 mb-8">
                  {[
                    { icon: "ri-award-fill", text: "Certifié COFRAC — Rapport accepté par tous les notaires", color: "text-[#F97316]" },
                    { icon: "ri-timer-flash-fill", text: "RDV sous 48h dans tous les arrondissements de Paris", color: "text-[#16A34A]" },
                    { icon: "ri-file-check-line", text: "Rapport complet envoyé par email le jour même", color: "text-white" },
                    { icon: "ri-price-tag-3-fill", text: "Dès 130 € TTC — Tarif fixe, sans surprise", color: "text-[#F59E0B]" },
                  ].map((pt) => (
                    <div key={pt.text} className="flex items-center gap-3">
                      <i className={`${pt.icon} ${pt.color} text-lg flex-shrink-0`}></i>
                      <span className="text-white/90 text-sm">{pt.text}</span>
                    </div>
                  ))}
                </div>

                {SHOW_REVIEWS && (
                  <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-5 py-3">
                    <div className="flex gap-0.5">
                      {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-[#F59E0B] text-sm"></i>)}
                    </div>
                    <span className="text-white font-bold text-sm">4.9/5</span>
                    <span className="text-white/60 text-sm">— 127 avis Google vérifiés</span>
                  </div>
                )}
              </div>

              {/* Right — Form */}
              <div className="flex justify-center lg:justify-end">
                <div className="w-full max-w-md">
                  <LpForm
                    preselectedDiag="dpe"
                    formTitle="Devis DPE Paris gratuit"
                    formSubtitle="Réponse sous 2h — Intervention sous 48h"
                    ctaLabel="Obtenir mon devis DPE gratuit"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Trust bar */}
        <section className="bg-white border-b border-gray-100 py-8">
          <div className="max-w-5xl mx-auto px-6">
            <div className="flex flex-wrap items-center justify-center gap-8">
              {[
                { icon: "ri-award-fill", label: "Certifié COFRAC", color: "text-[#F97316]" },
                { icon: "ri-shield-check-fill", label: "RC Pro assurée", color: "text-[#16A34A]" },
                { icon: "ri-timer-flash-fill", label: "RDV sous 48h", color: "text-[#F97316]" },
                { icon: "ri-file-check-line", label: "Rapport le jour même", color: "text-[#0F3B5F]" },
                ...(SHOW_REVIEWS ? [{ icon: "ri-star-fill", label: "4.9/5 Google", color: "text-[#F59E0B]" }] : []),
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2 text-sm font-semibold text-gray-600">
                  <i className={`${item.icon} ${item.color} text-lg`}></i>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pourquoi DPE obligatoire */}
        <section className="bg-[#F8FAFC] py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <span className="inline-block bg-orange-100 text-[#F97316] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
                  Pourquoi le DPE ?
                </span>
                <h2 className="text-3xl font-extrabold text-[#0F3B5F] mb-5" style={{ fontFamily: "Barlow, sans-serif" }}>
                  Le DPE est obligatoire pour vendre ou louer à Paris
                </h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Depuis la réforme de juillet 2021, le DPE est <strong>opposable juridiquement</strong>. Il doit obligatoirement figurer dans toute annonce immobilière et être annexé à la promesse de vente ou au bail de location.
                </p>
                <p className="text-gray-600 leading-relaxed mb-6">
                  À Paris, où le parc immobilier est majoritairement ancien, le DPE est un critère déterminant pour la <strong>valeur verte</strong> de votre bien. Un logement classé A ou B se vend en moyenne 15% plus cher qu'un logement classé F ou G.
                </p>
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
                  <div className="flex items-start gap-3">
                    <i className="ri-alert-fill text-amber-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <div>
                      <p className="font-bold text-amber-800 text-sm mb-1">Attention depuis 2025</p>
                      <p className="text-amber-700 text-sm">Les logements classés G sont interdits à la location depuis le 1er janvier 2025. Les logements F seront interdits à partir de 2028.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {[
                  { label: "Étiquette A", desc: "Très performant", color: "bg-green-500", text: "≤ 70 kWh/m²/an" },
                  { label: "Étiquette B", desc: "Performant", color: "bg-green-400", text: "71–110 kWh/m²/an" },
                  { label: "Étiquette C", desc: "Assez performant", color: "bg-yellow-400", text: "111–180 kWh/m²/an" },
                  { label: "Étiquette D", desc: "Peu performant", color: "bg-orange-400", text: "181–250 kWh/m²/an" },
                  { label: "Étiquette E", desc: "Énergivore", color: "bg-orange-500", text: "251–330 kWh/m²/an" },
                  { label: "Étiquette F", desc: "Très énergivore", color: "bg-red-400", text: "331–420 kWh/m²/an" },
                  { label: "Étiquette G", desc: "Passoire thermique", color: "bg-red-600", text: "&gt; 420 kWh/m²/an" },
                ].map((item) => (
                  <div key={item.label} className="bg-white rounded-xl p-4 border border-gray-100 flex items-center gap-3">
                    <div className={`w-10 h-10 ${item.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                      <span className="text-white font-extrabold text-lg">{item.label.split(" ")[1]}</span>
                    </div>
                    <div>
                      <div className="font-bold text-[#0F3B5F] text-xs">{item.label}</div>
                      <div className="text-[10px] text-gray-400">{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Zones Paris */}
        <section className="bg-white py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="text-center mb-10">
              <h2 className="text-3xl font-extrabold text-[#0F3B5F] mb-3" style={{ fontFamily: "Barlow, sans-serif" }}>
                DPE dans tous les arrondissements de Paris
              </h2>
              <p className="text-gray-500">Intervention sous 48h dans les 20 arrondissements</p>
            </div>
            <div className="flex flex-wrap gap-2 justify-center mb-10">
              {arrondissements.map((arr) => (
                <span key={arr} className="bg-[#F8FAFC] border border-gray-200 text-[#0F3B5F] text-sm font-medium px-4 py-2 rounded-full hover:border-[#F97316] hover:text-[#F97316] transition-colors cursor-default">
                  {arr}
                </span>
              ))}
            </div>
            <div className="text-center">
              <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 px-8 py-4 bg-[#F97316] text-white rounded-xl font-bold hover:bg-orange-600 transition-all whitespace-nowrap">
                <i className="ri-phone-fill"></i> Appeler pour un RDV express
              </a>
            </div>
          </div>
        </section>

        {/* Tarifs */}
        <section className="bg-[#F8FAFC] py-20">
          <div className="max-w-3xl mx-auto px-6">
            <div className="text-center mb-10">
              <h2 className="text-3xl font-extrabold text-[#0F3B5F] mb-3" style={{ fontFamily: "Barlow, sans-serif" }}>
                Tarifs DPE Paris — Transparents &amp; Fixes
              </h2>
              <p className="text-gray-500">Déplacement inclus, aucun frais caché</p>
            </div>
            <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden mb-6">
              <table className="w-full">
                <thead>
                  <tr className="bg-[#0F3B5F] text-white">
                    <th className="text-left px-6 py-4 text-sm font-bold">Type de bien</th>
                    <th className="text-right px-6 py-4 text-sm font-bold">Prix TTC</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { label: "Studio / T1 (< 35 m²)", price: "130 €", highlight: true },
                    { label: "T2 / T3 (35–80 m²)", price: "150 €", highlight: true },
                    { label: "T4+ / Maison (> 80 m²)", price: "180 €", highlight: true },
                    { label: "Local commercial", price: "Sur devis", highlight: false },
                  ].map((row, i) => (
                    <tr key={i} className={`border-b border-gray-50 hover:bg-orange-50/40 transition-colors ${row.highlight ? "border-l-4 border-l-[#F97316]" : ""} ${i % 2 === 0 ? "bg-white" : "bg-gray-50/40"}`}>
                      <td className="px-6 py-4 text-sm font-medium text-[#0F3B5F]">{row.label}</td>
                      <td className="px-6 py-4 text-right text-xl font-extrabold text-[#0F3B5F]" style={{ fontFamily: "Barlow, sans-serif" }}>{row.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Témoignages */}


        {SHOW_REVIEWS && (
        <section className="bg-white py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl font-extrabold text-[#0F3B5F]" style={{ fontFamily: "Barlow, sans-serif" }}>
                Ce que disent nos clients parisiens
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                { name: "Sophie M.", loc: "Paris 15e", text: "DPE réalisé en 1h30, rapport reçu le soir même. Parfait pour ma vente !", rating: 5, img: "/img/readdy/lp1t1.jpg" },
                { name: "Laurent P.", loc: "Paris 8e", text: "Diagnostiqueur ponctuel et professionnel. Rapport très détaillé, notaire satisfait.", rating: 5, img: "/img/readdy/lp1t2.jpg" },
                { name: "Nathalie V.", loc: "Paris 11e", text: "Excellent service, tarif transparent. Je recommande Up Diag sans hésitation.", rating: 5, img: "/img/readdy/lp1t3.jpg" },
              ].map((t) => (
                <div key={t.name} className="bg-[#F8FAFC] rounded-2xl p-6 border-l-4 border-[#F97316]">
                  <div className="flex gap-0.5 mb-3">
                    {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-[#F59E0B] text-sm"></i>)}
                  </div>
                  <p className="text-gray-600 text-sm italic mb-4">"{t.text}"</p>
                  <div className="flex items-center gap-3">
                    <img src={t.img} alt={t.name} className="w-10 h-10 rounded-full object-cover object-top" loading="lazy" />
                    <div>
                      <div className="font-bold text-[#0F3B5F] text-sm">{t.name}</div>
                      <div className="text-xs text-gray-400">{t.loc}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>


        )}

        {/* FAQ */}
        <section className="bg-[#F8FAFC] py-20">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-2xl font-extrabold text-[#0F3B5F] mb-8 text-center" style={{ fontFamily: "Barlow, sans-serif" }}>
              Questions fréquentes — DPE Paris
            </h2>
            <div className="flex flex-col gap-3">
              {faqItems.map((item, i) => (
                <FaqItemLP key={i} q={item.q} a={item.a} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="bg-[#0F3B5F] py-16">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-extrabold text-white mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
              Besoin d'un DPE à Paris ?
            </h2>
            <p className="text-white/75 mb-8">Devis gratuit en 2 min — Intervention sous 48h — Rapport le jour même</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="flex items-center justify-center gap-2 px-8 py-4 bg-[#F97316] text-white rounded-xl font-bold hover:bg-orange-600 transition-all whitespace-nowrap">
                <i className="ri-file-list-3-line"></i> Obtenir mon devis gratuit
              </a>
              <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-xl font-bold hover:bg-white/10 transition-all whitespace-nowrap">
                <i className="ri-phone-fill"></i> {PHONE}
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

function FaqItemLP({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`bg-white rounded-2xl border transition-all overflow-hidden ${open ? "border-[#F97316]" : "border-gray-100"}`}>
      <button className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer" onClick={() => setOpen(!open)}>
        <span className={`font-semibold text-sm pr-4 ${open ? "text-[#F97316]" : "text-[#0F3B5F]"}`}>{q}</span>
        <i className={`ri-arrow-down-s-line text-xl flex-shrink-0 transition-transform duration-300 ${open ? "rotate-180 text-[#F97316]" : "text-gray-400"}`}></i>
      </button>
      {open && <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-50 pt-4">{a}</div>}
    </div>
  );
}

import { useState } from "react";
import { SHOW_REVIEWS } from "@/config/features";
